module.exports = __webpack_public_path__ + "img/home-slider-3.e2b54de9.jpeg";